import { render, staticRenderFns } from "./docs-outline.vue?vue&type=template&id=da1865c0&"
var script = {}
import style0 from "./docs-outline.vue?vue&type=style&index=0&id=da1865c0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports